import {IsItem} from '@/models/IsItem'
import {Model} from '@/models/Model'
import {Product} from '@/models/Product'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const IssueConst = Object.freeze({
  STATUS_DRAFT: 1,
  STATUS_SUBMITTED_PENDING_CONFIRM: 2,
  STATUS_SUBMITTED_PENDING_APPROVE: 3,
  STATUS_APPROVED_PENDING_SYNC: 5,
  STATUS_SYNCED_PENDING_APPROVE: 6,

  STATUS_APPROVED_PENDING_OPC: 7,

  STATUS_WAIT_AT_POC: 8,
  STATUS_ON_DELIVERY: 9,
  STATUS_DONE: 10,
  STATUS_RETURN: 40,
  STATUS_OVERDUE: 50,

  STATUS_REJECT: 99,

  map(status: number): string {
    switch (status) {
      case IssueConst.STATUS_DRAFT:
        return 'ดราฟ'
      case IssueConst.STATUS_SUBMITTED_PENDING_CONFIRM:
        return 'รอยืนยัน'
      case IssueConst.STATUS_SUBMITTED_PENDING_APPROVE:
        return 'รออนุมัติ'
      case IssueConst.STATUS_APPROVED_PENDING_SYNC:
        return 'ส่งเข้า ERP'
      case IssueConst.STATUS_SYNCED_PENDING_APPROVE:
        return 'รออนุมัติ'
      case IssueConst.STATUS_APPROVED_PENDING_OPC:
        return 'รอส่ง OPC'
      case IssueConst.STATUS_WAIT_AT_POC:
        return 'ผลิดที่ OPC'
      case IssueConst.STATUS_ON_DELIVERY:
        return 'กำลังขนส่ง'
      case IssueConst.STATUS_DONE:
        return 'เสร็จ'
      case IssueConst.STATUS_OVERDUE:
        return 'มีปัญหา'
      case IssueConst.STATUS_RETURN:
        return 'คืน'
      case IssueConst.STATUS_REJECT:
        return 'ยกเลิก'
      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return 'ไม่ระบุ[' + status + ']'
  },

  mapShort(status: number): string {
    switch (status) {
      case IssueConst.STATUS_DRAFT:
        return 'ดราฟ'
      case IssueConst.STATUS_SUBMITTED_PENDING_CONFIRM:
        return 'รอยืนยัน'
      case IssueConst.STATUS_SUBMITTED_PENDING_APPROVE:
        return 'รออนุมัติ'
      case IssueConst.STATUS_APPROVED_PENDING_SYNC:
        return 'ส่งเข้า ERP'
      case IssueConst.STATUS_SYNCED_PENDING_APPROVE:
        return 'รออนุมัติ'
      case IssueConst.STATUS_APPROVED_PENDING_OPC:
        return 'ส่ง OPC'
      case IssueConst.STATUS_WAIT_AT_POC:
        return 'ผลิด'
      case IssueConst.STATUS_ON_DELIVERY:
        return 'ส่ง'
      case IssueConst.STATUS_DONE:
        return 'เสร็จ'
      case IssueConst.STATUS_RETURN:
        return 'คืน'
      case IssueConst.STATUS_REJECT:
        return 'ยกเลิก'
      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return 'ไม่ระบุ[' + status + ']'
  },

  color(status: number): string {
    switch (parseInt(`${status}`)) {
      case IssueConst.STATUS_DRAFT:
        return 'grey lighten-1'
      case IssueConst.STATUS_SUBMITTED_PENDING_CONFIRM:
        return 'red'
      case IssueConst.STATUS_SUBMITTED_PENDING_APPROVE:
        return 'grey lighten-1'
      case IssueConst.STATUS_APPROVED_PENDING_SYNC:
        return 'grey lighten-1'
      case IssueConst.STATUS_SYNCED_PENDING_APPROVE:
        return 'teal'
      case IssueConst.STATUS_APPROVED_PENDING_OPC:
        return 'lime'
      case IssueConst.STATUS_WAIT_AT_POC:
        return 'amber'
      case IssueConst.STATUS_ON_DELIVERY:
        return 'light-green'
      case IssueConst.STATUS_DONE:
        return 'blue-grey'
      case IssueConst.STATUS_RETURN:
        return 'blue-grey'
      case IssueConst.STATUS_REJECT:
        return 'red'

    }
    // debugger
    return ''
  },

})


export class Issue extends Model {

  created_at: Date | null
  updated_at: Date | null
  code: string | null
  doc_date: Date | null

  erp_is_at: Date | null
  status: number | null

  ref_code: string | null
  sku_code: string | null
  sku_name: string | null
  quantity: number | null

  items: IsItem[]
  mode: string | null

  product: Product
  mix_at: { mix_at: '' } | null

  mix_at_index: number | null
  mix_time: number | null
  remark: string | null


  getSkipField(): string[] {
    return ['timeline']
  }

  getResourceURL(): string {
    return Helper.setting.issue.getResourceAPI
  }

  async SubmitDraft(): Promise<Issue> {
    // debugger
    return await this.SetStatus(IssueConst.STATUS_SUBMITTED_PENDING_APPROVE)
  }

  async SetStatus(status: number): Promise<Issue> {
    // debugger
    this.status = status
    return await this.save<Issue>()
  }

}

export class DataIssue extends DataResource {

  declare data: Issue

}


export class DataIssuesArray extends DataArray {

  declare data: Issue[]
  filter: FilterIssue = new FilterIssue()
}


export class FilterIssue {

  status: FilterSet = new FilterSet()
}
